export default __webpack_public_path__ + "static/media/circle-01.3cc77656.png";